import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Note } from '../classes/note';
import config from '../config.json';

@Injectable({
    providedIn: 'root'
})
export class NoteService {
    API_NOTE_URL = config.serverAddress + ':' + config.serverPort + '/note/';

    constructor(private http: HttpClient) { }

    getAllByIDRequest(idRequest: number | string) {
        return this.http.get<Array<Note>>(this.API_NOTE_URL + 'request/' + idRequest);
    }

    create(note: Partial<Note>) {
        return this.http.post<Note>(this.API_NOTE_URL + 'create', note);
    }

    update(note: Partial<Note>) {
        return this.http.put<Note>(this.API_NOTE_URL + 'update', note);
    }

    delete(id: number | undefined) {
        return this.http.delete(this.API_NOTE_URL + 'delete/' + id);
    }
}
